import { Option } from '@inrev/core';
import { suretyTypeSchema, SuretyType } from '../enums.mjs';

const bySuretyType = (valueOf) => ({
    contract: valueOf(SuretyType.contract),
    compliance: valueOf(SuretyType.compliance),
    financial_guarantee: valueOf(SuretyType.financial_guarantee),
});
const entriesBySuretyType = (record) => suretyTypeSchema.options.flatMap((suretyType) => {
    const value = record[suretyType];
    return Option.isSome(value) ? [[suretyType, value]] : [];
});
const mapBySuretyType = (record, f) => entriesBySuretyType(record).reduce((mapped, [suretyType, value]) => {
    const result = f(value, suretyType);
    return Option.isSome(result) ? { ...mapped, [suretyType]: result } : mapped;
}, {});

export { bySuretyType, entriesBySuretyType, mapBySuretyType };
